var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPdfExtension = function SvgPdfExtension(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 20",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "pdf (1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ef5350",
    d: "M0 1.2A1.2 1.2 0 0 1 1.2 0H10l5 4.2v14.6a1.2 1.2 0 0 1-1.2 1.2H1.2A1.2 1.2 0 0 1 0 18.8Z",
    "data-name": "Pfad 651"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d32f2f",
    d: "M10 0v3a1.2 1.2 0 0 0 1.2 1.2H15",
    "data-name": "Pfad 652"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Gruppe 3686"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.764 12.681h-.469v1.438H2.257V9.788h1.369c1.182 0 1.857.463 1.857 1.413-.001 1.018-.694 1.48-1.719 1.48m-.125-2.157h-.344v1.407h.381a.65.65 0 0 0 .737-.732c.001-.455-.256-.675-.774-.675",
    "data-name": "Pfad 653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12 14.119H5.945V9.788h1.1c1.113 0 2.175.356 2.175 2.145.001 1.761-1.018 2.186-2.1 2.186m.075-3.582h-.213v2.832h.213c.569 0 .95-.306.95-1.438.001-1.156-.406-1.394-.952-1.394Z",
    "data-name": "Pfad 654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.026 10.524v1.138h1.513v.744h-1.513v1.713H9.982V9.788h2.857l-.106.737Z",
    "data-name": "Pfad 655"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPdfExtension);
export default ForwardRef;